<h1 class="_primary cell shrink"[i18nKey]="'intro.title'"></h1>

<kiwi-spacer [size]="32"></kiwi-spacer>

<div class="cell auto grid-x grid-margin-x">
    <div class="cell shrink blockContent">
        <div (click)="setStep(index)" *ngFor="let service of services; let index = index" class="menu-item"
             [ngClass]="{'_active' : currentStep == index}" [captureId]="service">
            {{('intro.' + service + '.title')|translate}}
        </div>
    </div>
    <app-generalities class="cell auto grid-y" *ngIf="services[currentStep] == 'generalities'"></app-generalities>
    <app-positioning class="cell auto grid-y" *ngIf="services[currentStep] == 'positioning'"></app-positioning>
    <app-human-resources class="cell auto grid-y"
                         *ngIf="services[currentStep] == 'human-resources'"></app-human-resources>
    <app-rooms class="cell auto grid-y" *ngIf="services[currentStep] == 'rooms'"></app-rooms>
    <app-menus class="cell auto grid-y" *ngIf="services[currentStep] == 'menus'"></app-menus>
</div>


